import React from 'react';
import { CountUp } from '../motion/CountUp';
import { Reveal, RevealText } from '../motion/Reveal';

const STATS = [
  { value: 24, suffix: '/7', label: 'Available' },
  { value: 500, suffix: '+', label: 'Happy Clients' },
  { value: 100, suffix: '%', label: 'Professional' },
  { text: 'UK Wide', label: 'Coverage' },
];

export const StatsBar = () => (
  <section className="border-b border-gray-200 bg-white py-20" data-testid="home-stats">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-y-12 md:divide-x divide-gray-200">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.1} className="text-center px-4">
          <div className="text-4xl md:text-5xl font-bold mb-3 text-black tracking-tight">
            {s.text ? <RevealText text={s.text} delay={0.2} /> : <CountUp value={s.value} suffix={s.suffix} testId={`stat-count-${i}`} />}
          </div>
          <div className="text-gray-500 text-xs uppercase tracking-[0.25em]">{s.label}</div>
        </Reveal>
      ))}
    </div>
  </section>
);
